module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box",
    staticStyle: {
      "overflow": "scroll !important"
    }
  }, [(false) ? _c('div', {
    staticClass: "huiyi-box-title"
  }, [_vm._v("我的业务")]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "huiyi-top-items"
  }, [_c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'HuiyiApplyList'
      }),
      expression: "{ name: 'HuiyiApplyList' }"
    }],
    staticClass: "item1",
    staticStyle: {
      "position": "relative",
      "padding-top": "3px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "huiyi-item-back-box"
  }, [_c('div', {
    staticClass: "huiyi-item-back hui-back-title1"
  }, [_vm._v("\n              " + _vm._s(_vm.row.huiyi_join_count) + "场\n            ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'SongpeiApplyList'
      }),
      expression: "{ name: 'SongpeiApplyList' }"
    }],
    staticClass: "item2",
    staticStyle: {
      "position": "relative",
      "padding-top": "3px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "huiyi-item-back-box"
  }, [_c('div', {
    staticClass: "huiyi-item-back hui-back-title2"
  }, [_vm._v("\n              " + _vm._s(_vm.row.huiyi_count) + "场\n            ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'CbaApplyList'
      }),
      expression: "{ name: 'CbaApplyList' }"
    }],
    staticClass: "item3",
    staticStyle: {
      "position": "relative",
      "padding-top": "3px"
    }
  }, [_vm._m(2), _vm._v(" "), _vm._m(3)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "huiyi-zc flex-start"
  }, [_c('div', {
    staticClass: "zc-left",
    on: {
      "click": function($event) {
        return _vm.setCurrent(77)
      }
    }
  }, [_c('div', {
    staticClass: "left-title1"
  }, [_vm._v("政策解读")]), _vm._v(" "), _c('div', {
    staticClass: "left-title2"
  }, [_vm._v("官方解读政策")]), _vm._v(" "), _c('div', {
    staticClass: "left-title3"
  }, [_vm._v("立即了解")])]), _vm._v(" "), _c('div', {
    staticClass: "zc-right"
  }, [_c('div', {
    staticClass: "zc-right-top flex-start"
  }, [_c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'MyExperience'
      }),
      expression: "{name: 'MyExperience'}"
    }],
    staticClass: "right-top1"
  }, [_c('div', {
    staticClass: "right-top-title1",
    staticStyle: {
      "color": "#996fe9"
    }
  }, [_vm._v("\n                资质查询\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "right-top-title2"
  }, [_vm._v("立即查看")])]), _vm._v(" "), _c('div', {
    staticClass: "right-top2",
    on: {
      "click": function($event) {
        return _vm.setCurrent(80)
      }
    }
  }, [_c('div', {
    staticClass: "right-top-title1",
    staticStyle: {
      "color": "#f2a3b8"
    }
  }, [_vm._v("\n                相关文件\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "right-top-title2"
  }, [_vm._v("立即查看")])])]), _vm._v(" "), _c('div', {
    staticClass: "zc-right-bottom",
    on: {
      "click": function($event) {
        return _vm.setCurrent(78)
      }
    }
  }, [_c('div', {
    staticClass: "right-bottom-title1",
    staticStyle: {
      "color": "#6698f8"
    }
  }, [_vm._v("\n              导师展示\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "right-bottom-title2"
  }, [_vm._v("优秀导师展示")]), _vm._v(" "), _c('div', {
    staticClass: "right-bottom-title3"
  }, [_vm._v("立即了解")])])])]), _vm._v(" "), _c('div', {
    staticClass: "huiyi-plan"
  }, [_c('img', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'HuiyiPlan',
        query: {},
      }),
      expression: "{\n                name: 'HuiyiPlan',\n                query: {  },\n              }"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20220425/user-0/20220425/d05dc136751dae130ee539f4b84f4a9a.png"
    }
  })]), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'HuiyiApplyList'
      }),
      expression: "{name:'HuiyiApplyList'}"
    }],
    attrs: {
      "is-link": "",
      "title": "我的会议培训",
      "label": '我已报名成功的会议培训' + _vm.row.huiyi_join_count + '场'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [(_vm.row.huiyi_count) ? _c('div', {
          staticClass: "badge"
        }, [_vm._v("报名中" + _vm._s(_vm.row.huiyi_count) + "场")]) : _vm._e()]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('van-cell', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'SongpeiApplyList'
      }),
      expression: "{name:'SongpeiApplyList'}"
    }],
    attrs: {
      "is-link": "",
      "title": "我的送培",
      "label": '我已报名成功送培' + _vm.row.songpei_join_count + '场'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [(_vm.row.songpei_count) ? _c('div', {
          staticClass: "badge"
        }, [_vm._v("报名中" + _vm._s(_vm.row.songpei_count) + "场")]) : _vm._e()]
      },
      proxy: true
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "huiyi-box-title"
  }, [_vm._v("报名入口")]), _vm._v(" "), _c('div', {
    staticClass: "baoming-item-box"
  }, _vm._l((_vm.row.group_list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "baoming-item",
      style: (_vm.getBackground(index)),
      on: {
        "click": function($event) {
          return _vm.onGroupBtn(item, index)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item.name) + "\n        ")])
  }), 0), _vm._v(" "), (_vm.groupRow) ? _c('div', {
    staticClass: "huiyi-box-title"
  }, [_vm._v(_vm._s(_vm.groupRow.name))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "huiyi-group-item-box"
  }, [_c('div', {
    staticClass: "group-item",
    on: {
      "click": _vm.goDetail
    }
  }, [_c('div', {
    staticClass: "group-item-back-box",
    style: ('width:100%;height:1.46rem;background-image: linear-gradient(to right, #ffb42b , #fbca70)')
  }, [_c('div', {
    staticClass: "group-item-taps"
  }, [_vm._v("我的")]), _vm._v(" "), _c('div', {
    staticClass: "group-item-num"
  }, [(_vm.groupRow.name == '七彩星级师资培训') ? _c('div', {
    staticClass: "group-item-num-mine"
  }, [_vm._v(_vm._s(_vm.row.cba_count) + "场")]) : (_vm.groupRow.name == '送培到基层') ? _c('div', {
    staticClass: "group-item-num-mine"
  }, [_vm._v(_vm._s(_vm.row.songpei_count) + "场")]) : _c('div', {
    staticClass: "group-item-num-mine"
  }, [_vm._v(_vm._s(_vm.row.huiyi_join_count) + "场")])])]), _vm._v(" "), (_vm.groupRow.name == '七彩星级师资培训') ? _c('div', {
    staticClass: "group-item-name-mine show-three-row"
  }, [_vm._v("\n            我的" + _vm._s(_vm.groupRow.name) + "\n          ")]) : (_vm.groupRow.name == '送培到基层') ? _c('div', {
    staticClass: "group-item-name-mine show-three-row"
  }, [_vm._v("\n            我的" + _vm._s(_vm.groupRow.name) + "\n          ")]) : _c('div', {
    staticClass: "group-item-name-mine show-three-row"
  }, [_vm._v("\n            我的会议培训\n          ")])]), _vm._v(" "), _vm._l((_vm.groupRow.list), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "group-item",
      on: {
        "click": function($event) {
          return _vm.apply(item)
        }
      }
    }, [_c('div', {
      staticClass: "group-item-back-box",
      style: ('width:100%;height:1.46rem;background-image: linear-gradient(to right, #' +
        item.color[0] +
        ' , #' +
        item.color[1] +
        ');')
    }, [(item.group_names) ? _c('div', {
      staticClass: "group-item-taps"
    }, [_vm._v(_vm._s(item.group_names))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "group-item-str"
    }, [_vm._v(_vm._s(item.date_str) + " \n            ")]), _vm._v(" "), _c('span', {
      staticClass: "group-item-location"
    }, [_vm._v("\n              " + _vm._s(item.province) + _vm._s(item.city) + "\n            ")]), _vm._v(" "), (item.is_pass) ? _c('div', {
      staticClass: "group-item-status"
    }, [_vm._v("结束")]) : _c('div', {
      staticClass: "group-item-status"
    }, [_vm._v("进行中")])]), _vm._v(" "), _c('div', {
      staticClass: "group-item-name show-three-row"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (item.onlycity == 1) ? _c('van-tag', {
      attrs: {
        "type": "warning"
      }
    }, [_vm._v("仅限 " + _vm._s(item.province) + _vm._s(item.city) + "参加")]) : (item.onlyprovince == 1) ? _c('van-tag', {
      attrs: {
        "type": "warning"
      }
    }, [_vm._v("仅限 " + _vm._s(item.province) + "参加")]) : _vm._e()], 1)
  })], 2), _vm._v(" "), (_vm.currentIndex == 0) ? _c('div') : (
    _vm.currentIndex == 1 ||
    _vm.currentIndex == 2 ||
    _vm.currentIndex == 3 ||
    _vm.currentIndex == 4
  ) ? _c('div', [(_vm.huiyiList.length > 0) ? _c('div', {
    staticClass: "more-box"
  }, [_c('div', {
    staticClass: "train-box flex-between",
    staticStyle: {
      "flex-wrap": "wrap"
    }
  }, _vm._l((_vm.huiyiList), function(row, index) {
    return _c('div', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'HuiyiApplyFormStep1',
          query: {
            saiqu_id: row.id
          },
        }),
        expression: "{\n                name: 'HuiyiApplyFormStep1',\n                query: { saiqu_id: row.id },\n              }"
      }],
      staticClass: "train-items"
    }, [_c('div', {
      staticClass: "train-items-top items-top1",
      style: ('background-image: linear-gradient(to right, #' +
        row.color[0] +
        ' , #' +
        row.color[1] +
        ');')
    }, [_c('div', [_c('div', {
      staticClass: "train-items-top-city"
    }, [_vm._v(_vm._s(row.location))]), _vm._v(" "), _c('div', {
      staticClass: "train-items-top-time"
    }, [_vm._v(_vm._s(row.date_str))])])]), _vm._v(" "), _c('div', {
      staticClass: "train-items-title"
    }, [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('div', {
      staticClass: "flex-between"
    }, [_c('div', {
      staticClass: "train-items-time"
    }, [_vm._v(_vm._s(row.startdate))]), _vm._v(" "), _c('div', {
      staticClass: "train-items-address"
    }, [_vm._v("\n                  " + _vm._s(row.province) + "·" + _vm._s(row.city) + "\n                ")])])])
  }), 0)]) : _c('van-empty', {
    attrs: {
      "description": "暂无场次"
    }
  })], 1) : (_vm.currentIndex > 10) ? _c('div', [(_vm.news_list.length > 0) ? _c('div', {
    staticClass: "box"
  }, _vm._l((_vm.news_list), function(row, i) {
    return _c('div', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'NewsDetail',
          query: {
            id: row.id
          }
        }),
        expression: "{ name: 'NewsDetail', query: { id: row.id } }"
      }],
      key: i
    }, [(row.pics.length == 0) ? _c('NewsItem1', {
      attrs: {
        "row": row
      }
    }) : _vm._e(), _vm._v(" "), (row.pics.length == 1) ? _c('NewsItem2', {
      attrs: {
        "row": row
      }
    }) : _vm._e(), _vm._v(" "), (false) ? _c('NewsItem3') : _vm._e(), _vm._v(" "), (row.pics.length > 1) ? _c('NewsItem4', {
      attrs: {
        "row": row
      }
    }) : _vm._e()], 1)
  }), 0) : _c('van-empty', {
    attrs: {
      "description": "暂无内容"
    }
  })], 1) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.row.doing.length > 0),
      expression: "row.doing.length > 0"
    }],
    staticClass: "more-box"
  }, [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "main-solid"
  }), _vm._v(" "), _c('div', {
    staticClass: "train-box flex-between",
    staticStyle: {
      "flex-wrap": "wrap"
    }
  }, _vm._l((_vm.row.doing), function(row, index) {
    return _c('div', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'HuiyiApplyFormStep1',
          query: {
            saiqu_id: row.id
          },
        }),
        expression: "{\n              name: 'HuiyiApplyFormStep1',\n              query: { saiqu_id: row.id },\n            }"
      }],
      key: index,
      staticClass: "train-items"
    }, [_c('div', {
      staticClass: "train-items-top items-top1",
      style: ('background-image: linear-gradient(to right, #' +
        row.color[0] +
        ' , #' +
        row.color[1] +
        ');')
    }, [_c('div', [_c('div', {
      staticClass: "train-items-top-city"
    }, [_vm._v(_vm._s(row.location))]), _vm._v(" "), _c('div', {
      staticClass: "train-items-top-time"
    }, [_vm._v(_vm._s(row.date_str))])])]), _vm._v(" "), _c('div', {
      staticClass: "train-items-title"
    }, [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('div', {
      staticClass: "flex-between"
    }, [_c('div', {
      staticClass: "train-items-time"
    }, [_vm._v(_vm._s(row.startdate))]), _vm._v(" "), _c('div', {
      staticClass: "train-items-address"
    }, [_vm._v("\n                " + _vm._s(row.province) + "·" + _vm._s(row.city) + "\n              ")])])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "huiyi-top-item"
  }, [_c('div', {
    staticClass: "top-item-title"
  }, [_vm._v("会议培训")]), _vm._v(" "), _c('img', {
    staticClass: "iocn-huiyi-zhuangshi",
    attrs: {
      "src": "https://static.dierqudao.com/images/cca/icon-huiyi-zhuangshi.png",
      "alt": "",
      "srcset": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "huiyi-top-item"
  }, [_c('div', {
    staticClass: "top-item-title"
  }, [_vm._v("送培到基层")]), _vm._v(" "), _c('img', {
    staticClass: "iocn-huiyi-zhuangshi",
    attrs: {
      "src": "https://static.dierqudao.com/images/cca/icon-huiyi-zhuangshi.png",
      "alt": "",
      "srcset": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "huiyi-top-item"
  }, [_c('div', {
    staticClass: "top-item-title"
  }, [_vm._v("七彩星级师资培训")]), _vm._v(" "), _c('img', {
    staticClass: "iocn-huiyi-zhuangshi",
    attrs: {
      "src": "https://static.dierqudao.com/images/cca/icon-huiyi-zhuangshi.png",
      "alt": "",
      "srcset": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "huiyi-item-back-box"
  }, [_c('div', {
    staticClass: "huiyi-item-back hui-back-title3"
  }, [_vm._v("0场")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "more-active"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "solid solid2"
  }), _vm._v(" "), _c('span', {
    staticClass: "more-title"
  }, [_vm._v("正在报名")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "more-items"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/pic-homepage-Meetings-and-training1.png"),
      "alt": "",
      "srcset": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("首次注册")])]), _vm._v(" "), _c('div', {
    staticClass: "more-items"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/pic-homepage-Meetings-and-training2.png"),
      "alt": "",
      "srcset": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("报名申请")])]), _vm._v(" "), _c('div', {
    staticClass: "more-items"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/pic-homepage-Meetings-and-training3.png"),
      "alt": "",
      "srcset": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("咨询查询")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ca0491a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/huiyi/HuiyiIndexTwo.vue
// module id = 2375
// module chunks = 0